<template>
  <main class="molecule-alert-selection-table_container">
    <section class="filter-box__container row g-0">
      <div class="col-12 col-md-5 g-0">
        <input
          type="text"
          v-model="filterText"
          class="filter-box--style"
          placeholder="Filter table"
        />
      </div>
    </section>

    <section class="custom-table__container">
      <div class="custom-table">
        <div class="table__header align-items--center justify-content--center">
          <atom-checkbox
            v-if="canUpdate"
            idx="checkAll"
            v-model="isCheckAll"
            @checkboxValueIndex="selectionChanged"
          ></atom-checkbox>
        </div>
        <div class="table__header align-items--center">NAME SERVER</div>
        <div class="table__header align-items--center">
          <atom-checkbox
            v-if="canUpdate"
            idx="checkAllCpu"
            v-model="isCheckAllCpu"
            @checkboxValueIndex="selectionChanged"
          ></atom-checkbox>
          <span>CPU</span>
        </div>
        <div class="table__header align-items--center">
          <atom-checkbox
            v-if="canUpdate"
            idx="checkAllMemory"
            v-model="isCheckAllMemory"
            @checkboxValueIndex="selectionChanged"
          ></atom-checkbox>
          <span>MEMORY</span>
        </div>
        <div class="table__header align-items--center">
          <atom-checkbox
            v-if="canUpdate"
            idx="checkAllStorage"
            v-model="isCheckAllStorage"
            @checkboxValueIndex="selectionChanged"
          ></atom-checkbox>
          <span>AVAILABLE STORAGE</span>
        </div>
      </div>
      <div
        v-for="(item, index) in itemValueFiltered"
        :key="index"
        class="custom-table p-0"
      >
        <div class="table__content align-items--center justify-content--center">
          <atom-checkbox
            v-if="canUpdate"
            :idx="item.id"
            v-model="item.isCheck"
            @checkboxValueIndex="selectionChanged"
          ></atom-checkbox>
        </div>
        <div class="table__content align-items--center">
          <span>{{ item.nameServer }}</span>
        </div>
        <div class="table__content align-items--center">
          <molecule-checkbox-threshold
            v-model="item.cpu.isSelect"
            :isDisable="item.cpu.isDisable"
            :warningValue="item.cpu.warningValue"
            :criticalValue="item.cpu.criticalValue"
            :canUpdate="canUpdate"
          ></molecule-checkbox-threshold>
        </div>
        <div class="table__content align-items--center">
          <molecule-checkbox-threshold
            v-model="item.memory.isSelect"
            :isDisable="item.memory.isDisable"
            :warningValue="item.memory.warningValue"
            :criticalValue="item.memory.criticalValue"
            :canUpdate="canUpdate"
          ></molecule-checkbox-threshold>
        </div>
        <div class="table__content align-items--center">
          <molecule-checkbox-threshold
            v-model="item.storage.isSelect"
            :isDisable="item.storage.isDisable"
            :warningValue="item.storage.warningValue"
            :criticalValue="item.storage.criticalValue"
            :canUpdate="canUpdate"
          ></molecule-checkbox-threshold>
        </div>
      </div>
    </section>
  </main>
</template>

<script>
import AtomCheckbox from "@/components/atoms/AtomCheckbox.vue"
import MoleculeCheckboxThreshold from "./MoleculeCheckboxThreshold.vue"
export default {
  name: "MoleculeAlertSelectionTable",
  components: {
    AtomCheckbox,
    MoleculeCheckboxThreshold,
  },
  props: {
    value: {
      type: Array,
      required: true,
    },
    canUpdate: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    itemValue: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit("input", value)
      },
    },
  },
  created() {
    this.checkField()
    this.cloneData()
  },
  data() {
    return {
      itemValueFiltered: [],
      filterText: "",
      isCheckAll: false,
      isCheckAllCpu: false,
      isCheckAllMemory: false,
      isCheckAllStorage: false,
    }
  },
  watch: {
    itemValue: {
      deep: true,
      handler() {
        this.checkField()
      },
    },
    filterText() {
      if (this.filterText === "") {
        this.itemValueFiltered = this.itemValue
      } else {
        this.itemValueFiltered = this.itemValue.filter((item) => {
          return (
            item.nameServer
              .toLowerCase()
              .indexOf(this.filterText.toLowerCase()) != -1
          )
        })
      }
    },
    itemValueFiltered: {
      deep: true,
      handler() {
        this.checkField()
        if (this.itemValueFiltered.length === 0) {
          this.isCheckAll = false
          this.isCheckAllCpu = false
          this.isCheckAllMemory = false
          this.isCheckAllStorage = false
        }
      },
    },
  },
  methods: {
    cloneData() {
      this.itemValueFiltered = Array.from(this.itemValue)
    },
    checkField() {
      if (this.filterText === "") {
        let check = true
        for (let i = 0; i < this.itemValue.length; i++) {
          check = true
          if (!this.itemValue[i].cpu.isDisable) {
            if (!this.itemValue[i].cpu.isSelect) {
              check = false
            }
          }
          if (!this.itemValue[i].memory.isDisable) {
            if (!this.itemValue[i].memory.isSelect) {
              check = false
            }
          }
          if (!this.itemValue[i].storage.isDisable) {
            if (!this.itemValue[i].storage.isSelect) {
              check = false
            }
          }
          this.itemValue[i].isCheck = check
        }
      } else {
        let check = true
        for (let i = 0; i < this.itemValueFiltered.length; i++) {
          check = true
          if (!this.itemValueFiltered[i].cpu.isDisable) {
            if (!this.itemValueFiltered[i].cpu.isSelect) {
              check = false
            }
          }
          if (!this.itemValueFiltered[i].memory.isDisable) {
            if (!this.itemValueFiltered[i].memory.isSelect) {
              check = false
            }
          }
          if (!this.itemValueFiltered[i].storage.isDisable) {
            if (!this.itemValueFiltered[i].storage.isSelect) {
              check = false
            }
          }
          this.itemValueFiltered[i].isCheck = check
        }
      }
      this.checkAllField()
      this.checkAllCpuField()
      this.checkAllMemoryField()
      this.checkAllStorageField()
    },
    checkAllField() {
      if (this.filterText === "") {
        let checkAll = true
        for (let i = 0; i < this.itemValue.length; i++) {
          if (!this.itemValue[i].isCheck) {
            checkAll = false
          }
        }
        if (checkAll) {
          this.isCheckAll = true
        } else {
          this.isCheckAll = false
        }
      } else {
        let checkAll = true
        for (let i = 0; i < this.itemValueFiltered.length; i++) {
          if (!this.itemValueFiltered[i].isCheck) {
            checkAll = false
          }
        }
        if (checkAll) {
          this.isCheckAll = true
        } else {
          this.isCheckAll = false
        }
      }
    },
    checkAllCpuField() {
      if (this.filterText === "") {
        let checkAllCpu = true
        for (let i = 0; i < this.itemValue.length; i++) {
          if (!this.itemValue[i].cpu.isDisable) {
            if (!this.itemValue[i].cpu.isSelect) {
              checkAllCpu = false
            }
          }
        }
        if (checkAllCpu) {
          this.isCheckAllCpu = true
        } else {
          this.isCheckAllCpu = false
        }
      } else {
        let checkAllCpu = true
        for (let i = 0; i < this.itemValueFiltered.length; i++) {
          if (!this.itemValueFiltered[i].cpu.isDisable) {
            if (!this.itemValueFiltered[i].cpu.isSelect) {
              checkAllCpu = false
            }
          }
        }
        if (checkAllCpu) {
          this.isCheckAllCpu = true
        } else {
          this.isCheckAllCpu = false
        }
      }
    },
    checkAllMemoryField() {
      if (this.filterText === "") {
        let checkAllMemory = true
        for (let i = 0; i < this.itemValue.length; i++) {
          if (!this.itemValue[i].memory.isDisable) {
            if (!this.itemValue[i].memory.isSelect) {
              checkAllMemory = false
            }
          }
        }
        if (checkAllMemory) {
          this.isCheckAllMemory = true
        } else {
          this.isCheckAllMemory = false
        }
      } else {
        let checkAllMemory = true
        for (let i = 0; i < this.itemValueFiltered.length; i++) {
          if (!this.itemValueFiltered[i].memory.isDisable) {
            if (!this.itemValueFiltered[i].memory.isSelect) {
              checkAllMemory = false
            }
          }
        }
        if (checkAllMemory) {
          this.isCheckAllMemory = true
        } else {
          this.isCheckAllMemory = false
        }
      }
    },
    checkAllStorageField() {
      if (this.filterText === "") {
        let checkAllStorage = true
        for (let i = 0; i < this.itemValue.length; i++) {
          if (!this.itemValue[i].storage.isDisable) {
            if (!this.itemValue[i].storage.isSelect) {
              checkAllStorage = false
            }
          }
        }
        if (checkAllStorage) {
          this.isCheckAllStorage = true
        } else {
          this.isCheckAllStorage = false
        }
      } else {
        let checkAllStorage = true
        for (let i = 0; i < this.itemValueFiltered.length; i++) {
          if (!this.itemValueFiltered[i].storage.isDisable) {
            if (!this.itemValueFiltered[i].storage.isSelect) {
              checkAllStorage = false
            }
          }
        }
        if (checkAllStorage) {
          this.isCheckAllStorage = true
        } else {
          this.isCheckAllStorage = false
        }
      }
    },
    selectionChanged(idx) {
      if (idx === "checkAll") {
        if (this.isCheckAll) {
          this.selectAllCard()
        } else {
          this.deselectAllCard()
        }
      } else if (idx === "checkAllCpu") {
        if (this.isCheckAllCpu) {
          this.selectAllCpuCard()
        } else {
          this.deselectAllCpuCard()
        }
      } else if (idx === "checkAllMemory") {
        if (this.isCheckAllMemory) {
          this.selectAllMemoryCard()
        } else {
          this.deselectAllMemoryCard()
        }
      } else if (idx === "checkAllStorage") {
        if (this.isCheckAllStorage) {
          this.selectAllStorageCard()
        } else {
          this.deselectAllStorageCard()
        }
      } else {
        if (this.filterText === "") {
          let index = this.itemValue.findIndex((object) => {
            return object.id === idx
          })
          if (this.itemValue[index].isCheck) {
            this.selectCardById(index)
          } else {
            this.deselectCardById(index)
          }
        } else {
          let indexfiltered = this.itemValueFiltered.findIndex((object) => {
            return object.id === idx
          })
          if (this.itemValueFiltered[indexfiltered].isCheck) {
            this.selectCardById(indexfiltered)
          } else {
            this.deselectCardById(indexfiltered)
          }
        }
      }
    },
    selectAllCard() {
      if (this.filterText === "") {
        for (let i = 0; i < this.itemValue.length; i++) {
          this.itemValue[i].isCheck = true
          if (!this.itemValue[i].cpu.isDisable) {
            if (!this.itemValue[i].cpu.isSelect) {
              this.itemValue[i].cpu.isSelect = true
            }
          }
          if (!this.itemValue[i].memory.isDisable) {
            if (!this.itemValue[i].memory.isSelect) {
              this.itemValue[i].memory.isSelect = true
            }
          }
          if (!this.itemValue[i].storage.isDisable) {
            if (!this.itemValue[i].storage.isSelect) {
              this.itemValue[i].storage.isSelect = true
            }
          }
        }
      } else {
        for (let i = 0; i < this.itemValueFiltered.length; i++) {
          this.itemValueFiltered[i].isCheck = true
          if (!this.itemValueFiltered[i].cpu.isDisable) {
            if (!this.itemValueFiltered[i].cpu.isSelect) {
              this.itemValueFiltered[i].cpu.isSelect = true
            }
          }
          if (!this.itemValueFiltered[i].memory.isDisable) {
            if (!this.itemValueFiltered[i].memory.isSelect) {
              this.itemValueFiltered[i].memory.isSelect = true
            }
          }
          if (!this.itemValueFiltered[i].storage.isDisable) {
            if (!this.itemValueFiltered[i].storage.isSelect) {
              this.itemValueFiltered[i].storage.isSelect = true
            }
          }
        }
      }
    },
    deselectAllCard() {
      if (this.filterText === "") {
        for (let i = 0; i < this.itemValue.length; i++) {
          this.itemValue[i].isCheck = false
          if (!this.itemValue[i].cpu.isDisable) {
            if (this.itemValue[i].cpu.isSelect) {
              this.itemValue[i].cpu.isSelect = false
            }
          }
          if (!this.itemValue[i].memory.isDisable) {
            if (this.itemValue[i].memory.isSelect) {
              this.itemValue[i].memory.isSelect = false
            }
          }
          if (!this.itemValue[i].storage.isDisable) {
            if (this.itemValue[i].storage.isSelect) {
              this.itemValue[i].storage.isSelect = false
            }
          }
        }
      } else {
        for (let i = 0; i < this.itemValueFiltered.length; i++) {
          this.itemValueFiltered[i].isCheck = false
          if (!this.itemValueFiltered[i].cpu.isDisable) {
            if (this.itemValueFiltered[i].cpu.isSelect) {
              this.itemValueFiltered[i].cpu.isSelect = false
            }
          }
          if (!this.itemValueFiltered[i].memory.isDisable) {
            if (this.itemValueFiltered[i].memory.isSelect) {
              this.itemValueFiltered[i].memory.isSelect = false
            }
          }
          if (!this.itemValueFiltered[i].storage.isDisable) {
            if (this.itemValueFiltered[i].storage.isSelect) {
              this.itemValueFiltered[i].storage.isSelect = false
            }
          }
        }
      }
    },
    selectAllCpuCard() {
      if (this.filterText === "") {
        for (let i = 0; i < this.itemValue.length; i++) {
          if (!this.itemValue[i].cpu.isDisable) {
            if (!this.itemValue[i].cpu.isSelect) {
              this.itemValue[i].cpu.isSelect = true
            }
          }
        }
      } else {
        for (let i = 0; i < this.itemValueFiltered.length; i++) {
          if (!this.itemValueFiltered[i].cpu.isDisable) {
            if (!this.itemValueFiltered[i].cpu.isSelect) {
              this.itemValueFiltered[i].cpu.isSelect = true
            }
          }
        }
      }
    },
    deselectAllCpuCard() {
      if (this.filterText === "") {
        this.isCheckAll = false
        for (let i = 0; i < this.itemValue.length; i++) {
          if (!this.itemValue[i].cpu.isDisable) {
            if (this.itemValue[i].cpu.isSelect) {
              this.itemValue[i].cpu.isSelect = false
            }
          }
        }
      } else {
        this.isCheckAll = false
        for (let i = 0; i < this.itemValueFiltered.length; i++) {
          if (!this.itemValueFiltered[i].cpu.isDisable) {
            if (this.itemValueFiltered[i].cpu.isSelect) {
              this.itemValueFiltered[i].cpu.isSelect = false
            }
          }
        }
      }
    },
    selectAllMemoryCard() {
      if (this.filterText === "") {
        for (let i = 0; i < this.itemValue.length; i++) {
          if (!this.itemValue[i].memory.isDisable) {
            if (!this.itemValue[i].memory.isSelect) {
              this.itemValue[i].memory.isSelect = true
            }
          }
        }
      } else {
        for (let i = 0; i < this.itemValueFiltered.length; i++) {
          if (!this.itemValueFiltered[i].memory.isDisable) {
            if (!this.itemValueFiltered[i].memory.isSelect) {
              this.itemValueFiltered[i].memory.isSelect = true
            }
          }
        }
      }
    },
    deselectAllMemoryCard() {
      if (this.filterText === "") {
        this.isCheckAll = false
        for (let i = 0; i < this.itemValue.length; i++) {
          if (!this.itemValue[i].memory.isDisable) {
            if (this.itemValue[i].memory.isSelect) {
              this.itemValue[i].memory.isSelect = false
            }
          }
        }
      } else {
        this.isCheckAll = false
        for (let i = 0; i < this.itemValueFiltered.length; i++) {
          if (!this.itemValueFiltered[i].memory.isDisable) {
            if (this.itemValueFiltered[i].memory.isSelect) {
              this.itemValueFiltered[i].memory.isSelect = false
            }
          }
        }
      }
    },
    selectAllStorageCard() {
      if (this.filterText === "") {
        for (let i = 0; i < this.itemValue.length; i++) {
          if (!this.itemValue[i].storage.isDisable) {
            if (!this.itemValue[i].storage.isSelect) {
              this.itemValue[i].storage.isSelect = true
            }
          }
        }
      } else {
        for (let i = 0; i < this.itemValueFiltered.length; i++) {
          if (!this.itemValueFiltered[i].storage.isDisable) {
            if (!this.itemValueFiltered[i].storage.isSelect) {
              this.itemValueFiltered[i].storage.isSelect = true
            }
          }
        }
      }
    },
    deselectAllStorageCard() {
      if (this.filterText === "") {
        this.isCheckAll = false
        for (let i = 0; i < this.itemValue.length; i++) {
          if (!this.itemValue[i].storage.isDisable) {
            if (this.itemValue[i].storage.isSelect) {
              this.itemValue[i].storage.isSelect = false
            }
          }
        }
      } else {
        this.isCheckAll = false
        for (let i = 0; i < this.itemValueFiltered.length; i++) {
          if (!this.itemValueFiltered[i].storage.isDisable) {
            if (this.itemValueFiltered[i].storage.isSelect) {
              this.itemValueFiltered[i].storage.isSelect = false
            }
          }
        }
      }
    },
    selectCardById(index) {
      if (this.filterText === "") {
        if (!this.itemValue[index].cpu.isDisable) {
          if (!this.itemValue[index].cpu.isSelect) {
            this.itemValue[index].cpu.isSelect = true
          }
        }
        if (!this.itemValue[index].memory.isDisable) {
          if (!this.itemValue[index].memory.isSelect) {
            this.itemValue[index].memory.isSelect = true
          }
        }
        if (!this.itemValue[index].storage.isDisable) {
          if (!this.itemValue[index].storage.isSelect) {
            this.itemValue[index].storage.isSelect = true
          }
        }
      } else {
        if (!this.itemValueFiltered[index].cpu.isDisable) {
          if (!this.itemValueFiltered[index].cpu.isSelect) {
            this.itemValueFiltered[index].cpu.isSelect = true
          }
        }
        if (!this.itemValueFiltered[index].memory.isDisable) {
          if (!this.itemValueFiltered[index].memory.isSelect) {
            this.itemValueFiltered[index].memory.isSelect = true
          }
        }
        if (!this.itemValueFiltered[index].storage.isDisable) {
          if (!this.itemValueFiltered[index].storage.isSelect) {
            this.itemValueFiltered[index].storage.isSelect = true
          }
        }
      }
    },
    deselectCardById(index) {
      if (this.filterText === "") {
        this.isCheckAll = false
        if (!this.itemValue[index].cpu.isDisable) {
          if (this.itemValue[index].cpu.isSelect) {
            this.itemValue[index].cpu.isSelect = false
          }
        }
        if (!this.itemValue[index].memory.isDisable) {
          if (this.itemValue[index].memory.isSelect) {
            this.itemValue[index].memory.isSelect = false
          }
        }
        if (!this.itemValue[index].storage.isDisable) {
          if (this.itemValue[index].storage.isSelect) {
            this.itemValue[index].storage.isSelect = false
          }
        }
      } else {
        this.isCheckAll = false
        if (!this.itemValueFiltered[index].cpu.isDisable) {
          if (this.itemValueFiltered[index].cpu.isSelect) {
            this.itemValueFiltered[index].cpu.isSelect = false
          }
        }
        if (!this.itemValueFiltered[index].memory.isDisable) {
          if (this.itemValueFiltered[index].memory.isSelect) {
            this.itemValueFiltered[index].memory.isSelect = false
          }
        }
        if (!this.itemValueFiltered[index].storage.isDisable) {
          if (this.itemValueFiltered[index].storage.isSelect) {
            this.itemValueFiltered[index].storage.isSelect = false
          }
        }
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.filter-box__container {
  padding: 0 20px;
}

.filter-box--style {
  height: 38px;
  width: 100%;
  border: 1px solid #d8d6de;
  box-sizing: border-box;
  border-radius: 5px;
  background: #ffffff;
  padding-left: 15px;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out,
    padding 0.15s ease-in-out;
  &:active,
  &:focus {
    outline: none;
    border: 1px solid #7367f0;
  }
  &::placeholder {
    color: #b9b9c3;
  }
  &:active::placeholder,
  &:focus::placeholder {
    padding-left: 3px;
  }
}

.custom-table__container {
  width: 100%;
  margin-top: 20px;
  max-height: 621px;
  overflow: auto;
}

.custom-table {
  display: grid;
  grid-template-columns: minmax(60px, 1fr) minmax(150px, 3fr) repeat(
      3,
      minmax(150px, 3fr)
    );
}

.table__header {
  display: flex;
  height: 40px;
  color: #5e5873;
  font-weight: 600;
  font-size: 12px;
  background-color: #f3f2f7;
  border-top: 1px solid #ebe9f1;
  border-bottom: 1px solid #ebe9f1;
}

.table__content {
  display: flex;
  min-height: 58px;
  color: #6e6b7b;
  font-weight: 400;
  font-size: 14px;
  background: #ffffff;
  border-bottom: 1px solid #ebe9f1;
}

.align-items--center {
  align-items: center;
}

.justify-content--center {
  justify-content: center;
}

// Small devices (landscape phones, 576px and up)
@media screen and (min-width: 576px) {
}

// Medium devices (tablets, 768px and up)
@media screen and (min-width: 768px) {
  .filter-box__container {
    padding: 0;
  }
  .filter-box--style {
    margin-left: 20px;
  }
  .custom-table {
    grid-template-columns: minmax(60px, 1fr) minmax(250px, 5fr) repeat(
        3,
        minmax(150px, 3fr)
      );
  }
}

// Large devices (desktops, 992px and up)
@media screen and (min-width: 992px) {
}

// X-Large devices (large desktops, 1200px and up)
@media screen and (min-width: 1200px) {
}
</style>
